var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "header", attrs: { id: "header" } }, [
    _c("div", { staticClass: "l-center" }, [
      _c("nav", { staticClass: "nav ff--trajanpro-bold" }, [
        _c("ul", [
          _c(
            "li",
            {
              directives: [
                {
                  name: "gtag",
                  rawName: "v-gtag:nav",
                  value: _vm.$locale.header.join,
                  expression: "$locale.header.join",
                  arg: "nav",
                },
              ],
              staticClass: "nav-item",
            },
            [
              _c("a", { attrs: { href: "#join" } }, [
                _vm._v(_vm._s(_vm.$locale.header.join)),
              ]),
            ]
          ),
          _c(
            "li",
            {
              directives: [
                {
                  name: "gtag",
                  rawName: "v-gtag:nav",
                  value: _vm.$locale.header.kol,
                  expression: "$locale.header.kol",
                  arg: "nav",
                },
              ],
              staticClass: "nav-item",
            },
            [
              _c("a", { attrs: { href: "#kol" } }, [
                _vm._v(_vm._s(_vm.$locale.header.kol)),
              ]),
            ]
          ),
          _vm.isLogin && _vm.isJoinCivi
            ? _c(
                "li",
                {
                  directives: [
                    {
                      name: "gtag",
                      rawName: "v-gtag:nav",
                      value: _vm.$locale.header.rank,
                      expression: "$locale.header.rank",
                      arg: "nav",
                    },
                  ],
                  staticClass: "nav-item",
                },
                [
                  _c("a", { attrs: { href: "#rank" } }, [
                    _vm._v(_vm._s(_vm.$locale.header.rank)),
                  ]),
                ]
              )
            : _vm._e(),
          _c(
            "li",
            {
              directives: [
                {
                  name: "gtag",
                  rawName: "v-gtag:nav",
                  value: _vm.$locale.header.data,
                  expression: "$locale.header.data",
                  arg: "nav",
                },
              ],
              staticClass: "nav-item",
            },
            [
              _c("a", { attrs: { href: "#list" } }, [
                _vm._v(_vm._s(_vm.$locale.header.data)),
              ]),
            ]
          ),
          _c(
            "li",
            {
              directives: [
                {
                  name: "gtag",
                  rawName: "v-gtag:nav",
                  value: _vm.$locale.header.rewards,
                  expression: "$locale.header.rewards",
                  arg: "nav",
                },
              ],
              staticClass: "nav-item",
            },
            [
              _c("a", { attrs: { href: "#rewards" } }, [
                _vm._v(_vm._s(_vm.$locale.header.rewards)),
              ]),
            ]
          ),
          _c(
            "li",
            {
              directives: [
                {
                  name: "gtag",
                  rawName: "v-gtag:nav",
                  value: _vm.$locale.header.follow,
                  expression: "$locale.header.follow",
                  arg: "nav",
                },
              ],
              staticClass: "nav-item",
            },
            [
              _c("a", { attrs: { href: "#follow" } }, [
                _vm._v(_vm._s(_vm.$locale.header.follow)),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }